/**
 * @file pages-tab.tsx
 * @module app/modules/setting/pages-tab
 * @description Pages tab for managing page-related settings and configurations.
 * Hosts Terms & Conditions and Privacy Policy as sub-tabs, replacing the
 * deprecated standalone pages under app/modules/settings.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.9
 * @version 1.3.3
 */

import { useState } from 'react';
import { Card, Nav } from 'react-bootstrap';
import PagesTermsCondition from './pages-terms-condition';
import PagesPrivacyPolicy from './pages-privacy-policy';

const PAGES_SUB_TABS = [
  {
    key: 'terms-condition',
    label: 'Terms & Conditions',
  },
  {
    key: 'privacy-policy',
    label: 'Privacy Policy',
  },
];

/**
 * Pages tab component with Terms & Conditions / Privacy Policy sub-tabs.
 * @returns {JSX.Element} Pages tab content.
 */
const PagesTab = () => {
  const [activeSubTab, setActiveSubTab] = useState(PAGES_SUB_TABS[0].key);

  /**
   * Resolves content for the active sub-tab.
   * @returns {JSX.Element} Active sub-tab component.
   */
  const renderSubTabContent = () => {
    if (activeSubTab === 'privacy-policy') {
      return <PagesPrivacyPolicy />;
    }

    return <PagesTermsCondition />;
  };

  return (
    <Card className="setting-panel-card">
      <Card.Body className="setting-panel-body">
        <Nav variant="pills" className="setting-tabs mb-3">
          {PAGES_SUB_TABS.map((tab) => (
            <Nav.Item key={tab.key}>
              <Nav.Link
                active={activeSubTab === tab.key}
                onClick={() => setActiveSubTab(tab.key)}
                className="setting-tab-link"
              >
                {tab.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {renderSubTabContent()}
      </Card.Body>
    </Card>
  );
};

export default PagesTab;